export const PAGINACION = {
  total: 1,
  currentPage: 1,
  perPage: 20,
};